// extracted by mini-css-extract-plugin
export default {"packageCard":"packageCard__ODMwY","preview":"preview__YTI1Z","fade":"fade__MzUzM","moreButtonContainer":"moreButtonContainer__NmMxN","moreButton":"moreButton__ZjQwM"};